import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const SessionTimer = ({ sessionInfo }) => {
  const [remainingTime, setRemainingTime] = useState(null);

  useEffect(() => {
    if (!sessionInfo?.expires_at) return;

    // Convert expiry time to milliseconds
    const expiry = new Date(sessionInfo.expires_at).getTime();

    const updateTimer = () => {
      const now = Date.now();
      const diff = expiry - now;

      if (diff <= 0) {
        setRemainingTime(0);
        return;
      }
      setRemainingTime(diff);
    };

    // Run immediately and then every second
    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [sessionInfo]);

  if (remainingTime === null) return null;

  // Convert milliseconds to mm:ss
  const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
  const seconds = Math.floor((remainingTime / 1000) % 60);

  const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        ⏳ Session Expires In:{" "}
        <span
          style={{
            fontWeight: 600,
            fontSize: "16px",
            color: remainingTime < 60000 ? "red" : "green",
            backgroundColor: "#e5f2ffff",
            borderRadius: "12px",
            padding: "4px 8px",
          }}
        >
          {formattedTime}
        </span>
      </Typography>
    </Box>
  );
};

export default SessionTimer;
